import React from "react";
import styled from "styled-components";
import { breakpoints } from './constants';

const Selector = styled.div`
  position: relative;
  margin: ${props => props.marginBottom ? '50px 0' : '0'};
  z-index: 3;
  img, p {
    display: inline-block;
    vertical-align: middle;
  }
  li {
    text-align: center;
    &:hover {
      text-decoration: underline;
    }
  }
  p {
    text-align: center;
    margin: 0 10px 0 5px;
    &:hover {
      text-decoration: underline;
    }
  }
  @media (min-width: ${breakpoints.desktop}) {
    margin: ${props => props.marginBottom ? '0 0 80px 0' : '0'};
  }
`;

export default Selector;



// WEBPACK FOOTER //
// ./src/styled-components/Selector.js